import React, { useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock, Instagram, Facebook } from 'lucide-react';
const WhatsAppIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-12">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-13" />
  </svg>;
const TikTokIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-14">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" data-id="element-15" />
  </svg>;
export function Contacto() {
  const [formData, setFormData] = useState({
    nombre: '',
    whatsapp: '',
    servicio: '',
    mensaje: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = `Hola El Rey Barba 👑%0A%0ANombre: ${formData.nombre}%0AWhatsApp: ${formData.whatsapp}%0AServicio: ${formData.servicio}%0AMensaje: ${formData.mensaje}`;
    window.open(`https://wa.me/573028281216?text=${message}`, '_blank');
  };
  return <section id="contacto" className="py-20 bg-deepblack" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-18">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-bone mb-4" data-id="element-19">
            Visítanos o Escríbenos
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12" data-id="element-20">
          {/* Left Column - Contact Info + Map */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-21">
            <div className="space-y-6" data-id="element-22">
              <div className="flex items-start gap-4" data-id="element-23">
                <MapPin className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-24" />
                <div data-id="element-25">
                  <p className="text-bone font-semibold mb-1" data-id="element-26">
                    Cra 71F # 64-15 Sur
                  </p>
                  <p className="text-bone/70 text-sm" data-id="element-27">
                    Barrio Perdomo, Bogotá, Colombia
                  </p>
                  <p className="text-bone/70 text-sm" data-id="element-28">
                    Ref: Calle 63 sur #71B - 63
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-29">
                <Phone className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-30" />
                <div data-id="element-31">
                  <p className="text-bone" data-id="element-32">302 828 1216</p>
                  <p className="text-bone" data-id="element-33">301 701 6307</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-34">
                <Mail className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-35" />
                <p className="text-bone" data-id="element-36">Barberilaelreybarba@gmail.com</p>
              </div>

              <div className="flex items-start gap-4" data-id="element-37">
                <Clock className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-38" />
                <div data-id="element-39">
                  <p className="text-bone font-semibold" data-id="element-40">Domingo a Domingo</p>
                  <p className="text-gold" data-id="element-41">8:30 AM — 9:30 PM</p>
                </div>
              </div>
            </div>

            {/* Social Media Links */}
            <div className="space-y-3 pt-6 border-t border-gold/30" data-id="element-42">
              <a href="https://instagram.com/barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gold hover:text-white transition-colors" data-id="element-43">
                <Instagram className="w-5 h-5" data-id="element-44" />
                <span data-id="element-45">@barberiaelreybarba</span>
              </a>
              <a href="https://facebook.com/Barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gold hover:text-white transition-colors" data-id="element-46">
                <Facebook className="w-5 h-5" data-id="element-47" />
                <span data-id="element-48">@Barberiaelreybarba</span>
              </a>
              <a href="https://wa.me/573028281216" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gold hover:text-white transition-colors" data-id="element-49">
                <WhatsAppIcon data-id="element-50" />
                <span data-id="element-51">302 828 1216</span>
              </a>
              <a href="https://www.tiktok.com/@pablosievorivas" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gold hover:text-white transition-colors" data-id="element-52">
                <TikTokIcon data-id="element-53" />
                <span data-id="element-54">@pablosievorivas</span>
              </a>
            </div>

            {/* Google Maps */}
            <div className="rounded-lg overflow-hidden border-2 border-gold h-80" data-id="element-55">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3977.2!2d-74.15!3d4.55!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNMKwMzMnMDAuMCJOIDc0wrAwOScwMC4wIlc!5e0!3m2!1sen!2sco!4v1234567890" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" title="Ubicación El Rey Barba Barbería" data-id="element-56"></iframe>
            </div>
          </motion.div>

          {/* Right Column - Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-57">
            <form onSubmit={handleSubmit} className="space-y-6 bg-black/40 p-8 rounded-lg border border-gold/30" data-id="element-58">
              <div data-id="element-59">
                <label htmlFor="nombre" className="block text-bone font-medium mb-2" data-id="element-60">
                  Nombre completo *
                </label>
                <input type="text" id="nombre" required value={formData.nombre} onChange={e => setFormData({
                ...formData,
                nombre: e.target.value
              })} className="w-full px-4 py-3 bg-deepblack border border-gold/30 rounded-lg text-bone focus:outline-none focus:border-gold transition-colors" data-id="element-61" />
              </div>

              <div data-id="element-62">
                <label htmlFor="whatsapp" className="block text-bone font-medium mb-2" data-id="element-63">
                  Número de WhatsApp *
                </label>
                <input type="tel" id="whatsapp" required value={formData.whatsapp} onChange={e => setFormData({
                ...formData,
                whatsapp: e.target.value
              })} className="w-full px-4 py-3 bg-deepblack border border-gold/30 rounded-lg text-bone focus:outline-none focus:border-gold transition-colors" data-id="element-64" />
              </div>

              <div data-id="element-65">
                <label htmlFor="servicio" className="block text-bone font-medium mb-2" data-id="element-66">
                  Servicio de interés
                </label>
                <select id="servicio" value={formData.servicio} onChange={e => setFormData({
                ...formData,
                servicio: e.target.value
              })} className="w-full px-4 py-3 bg-deepblack border border-gold/30 rounded-lg text-bone focus:outline-none focus:border-gold transition-colors" data-id="element-67">
                  <option value="" data-id="element-68">Selecciona un servicio</option>
                  <option value="Corte básico ($15.000)" data-id="element-69">
                    Corte básico ($15.000)
                  </option>
                  <option value="Barba Premium ($10.000)" data-id="element-70">
                    Barba Premium ($10.000)
                  </option>
                  <option value="Membresía Bronze ($39.000)" data-id="element-71">
                    Membresía Bronze ($39.000)
                  </option>
                  <option value="Membresía Silver Padre e Hijo ($38.000)" data-id="element-72">
                    Membresía Silver Padre e Hijo ($38.000)
                  </option>
                  <option value="Membresía Gold Corte y Barba ($42.000)" data-id="element-73">
                    Membresía Gold Corte y Barba ($42.000)
                  </option>
                  <option value="Facial Completo ($40.000)" data-id="element-74">
                    Facial Completo ($40.000)
                  </option>
                  <option value="Tratamiento de barba Minoxidil ($120.000)" data-id="element-75">
                    Tratamiento de barba Minoxidil ($120.000)
                  </option>
                  <option value="Otro servicio" data-id="element-76">Otro servicio</option>
                </select>
              </div>

              <div data-id="element-77">
                <label htmlFor="mensaje" className="block text-bone font-medium mb-2" data-id="element-78">
                  Mensaje adicional
                </label>
                <textarea id="mensaje" rows={4} value={formData.mensaje} onChange={e => setFormData({
                ...formData,
                mensaje: e.target.value
              })} className="w-full px-4 py-3 bg-deepblack border border-gold/30 rounded-lg text-bone focus:outline-none focus:border-gold transition-colors resize-none" data-id="element-79"></textarea>
              </div>

              <button type="submit" className="w-full flex items-center justify-center gap-2 bg-gold text-deepblack px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-500 transition-all shadow-lg hover:shadow-gold-glow" data-id="element-80">
                <WhatsAppIcon data-id="element-81" />
                Enviar por WhatsApp
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}